import React from "react"

import { formatHeadingFontFamily } from "../WebsiteBuilderV2/utils/fontUtils"
import { scopePath } from "../WebsiteBuilderV2/utils/urlUtils"

const BlogPostFooter = ({ practice, theme }) => {
  const freeService = (practice?.services || []).find((service) => service.amountCents === 0)
  const textDarkColor = theme?.colors?.textDark || "#55433f"
  const accentColor = theme?.colors?.primary || theme?.colors?.accent || "#4A90E2"
  const bgLightColor = theme?.colors?.bgLight || theme?.colors?.white || "#FFFFFF"
  const greyLightestColor = theme?.colors?.greyLightest || "#f4ece9"
  const headingFont = formatHeadingFontFamily(theme?.fonts?.heading)

  const homeUrl = scopePath("/", practice)

  return (
    <div className="flex w-full flex-col gap-8">
      {freeService ? (
        <div className="rounded-lg p-6" style={{ backgroundColor: greyLightestColor }}>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h3
                className="mb-2 text-2xl font-bold"
                style={{ color: textDarkColor, fontFamily: headingFont, fontWeight: theme?.fonts?.headingWeight }}>
                Book a free discovery call
              </h3>
              <p className="text-base" style={{ color: textDarkColor }}>
                Learn more about this practitioner and how they can help you.
              </p>
            </div>
            <a
              href={scopePath(`/services/${freeService.publicSlug || freeService.id}`, practice)}
              className="inline-block whitespace-nowrap rounded px-6 py-3 text-center font-semibold transition-opacity hover:opacity-90"
              style={{ backgroundColor: accentColor, color: bgLightColor }}>
              Book for free
            </a>
          </div>
        </div>
      ) : (
        <div className="rounded-lg p-6 text-center" style={{ backgroundColor: greyLightestColor }}>
          <h3
            className="mb-4 text-2xl font-bold"
            style={{ color: textDarkColor, fontFamily: headingFont, fontWeight: theme?.fonts?.headingWeight }}>
            Ready to work together?
          </h3>
          <a
            href={homeUrl}
            className="inline-block rounded px-6 py-3 font-semibold transition-opacity hover:opacity-90"
            style={{ backgroundColor: accentColor, color: bgLightColor }}>
            Work with me
          </a>
        </div>
      )}
    </div>
  )
}

export default BlogPostFooter
